<template>
    <div class="chatList">
        <el-tabs @tab-click="onchange">
            <el-tab-pane :label="y.name" v-for="(y,index) in grouplist" :key="index">
                <div class="item_b" v-infinite-scroll="load" :key="acindex">
                    <div class="y_item" v-for="c in listcon" :key="c.id" @click="sendcon(c)">
                        <div class="tit">{{c.title}}</div>
                        <div class="con" v-html="c.body"></div>
                    </div>
                    <div v-if="listcon.length==0" class="nullcon"> 暂无内容</div>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import {
        mapState
    } from 'vuex'
    import {
        HappyScroll
    } from 'vue-happy-scroll'
    export default {
        name: "chatList",
        props: ['to_user'],
        data() {
            return {
                grouplist: [

                ],
                listcon: [],
                ids: '',
                page: 1,
                acindex:1,
            }
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            }),
        },
        mounted() {

        },
        created() {
            this.getList()
        },
        methods: {
            getList() {
                this.grouplist = [{
                        id: '',
                        name: '常用话术'
                    },
                    {
                        id: 0,
                        name: '自定义话术'
                    },
                ]
                axios.post('/admin/pc/consult/content/group_list', {}, {
                    token: true
                }).then(res => {
                    this.grouplist.push(...res.data.data.data)
                }).catch((error) => {
                    console.log(error);
                })
            },
            onchange(tab) {
                this.acindex++
                if (!tab.index) {
                    this.page=1
                    this.listcon =[]
                } else {
                    this.ids = this.grouplist[tab.index].id
                    this.page=1
                    this.listcon =[]
                }
                // this.getcon()
            },
            load() {
                this.getcon()
            },
            getcon() {
                axios.post('/admin/pc/consult/content/content_list', {
                    group_id: this.ids,
                    page: this.page
                }, {
                    token: true
                }).then(res => {
                    let data = res.data.data.data
                    if (data && data.length > 0) {
                        this.listcon = this.listcon.concat(data)
                        this.page++
                    }

                }).catch((error) => {
                    console.log(error);
                })
            },

            // 选择
            sendcon(item) {
                this.$nextTick(() => {
                    function delHtmlTag(str) {
                        return str.replace(/<[^>]+>/g, "");
                    }
                    let str = delHtmlTag(item.body);
                    this.$parent.value.text = str
                })

            },
        },
        destroyed() {}
    }
</script>

<style lang="scss" scoped>
    .chatList {

        width: 100%;
        height: 742px;
        border-right: 1px solid #ECECEC;
        overflow: auto;

        .item_b {
            height: 686px;
            overflow: auto;
        }

        .y_item {
            padding: 5px;
            // margin-bottom: 5px;
            border-bottom: 1px solid #f7f7f7;
            cursor: pointer;

            .tit {}

            .con {
                font-size: 14px;
                color: #999;
            }
        }

        .nullcon {
            color: #545454;
            text-align: center;
        }


    }



    .chart-scroll {
        margin-top: -10px;
    }
</style>